import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpTsoSearch', pkpTsoSearch);

    /**
     * This is a directive for the TSO search an advanced results list.
     *
     * @author sosoehng.prv
     * @ngInject
     */
    function pkpTsoSearch() {
        return {
            restrict: 'E',
            scope: {
                submitSelection: '&',
                filterMarketAreas: '='
            },
            template: require('app/_directives/pkp-tso-search.directive.html'),
            controller: TsoSearchController,
            controllerAs: 'tsoSearchCtrl'
        };

        function TsoSearchController(
            $scope,
            TransmissionSystemOperator,
            $filter
        ) {
            var vm = this;

            vm.suggestions = [];
            vm.search = {
                tso: {
                    name: '',
                    searchText: ''
                }
            };
            vm.cancel = cancel;
            vm.submitTsos = submitTsos;
            vm.selectAll = selectAll;
            vm.deselectAll = deselectAll;
            vm.onToggle = onToggle;
            vm.getTsos = getTsos;
            vm.widthOfScrollbar = widthOfScrollbar;
            vm.placeholderDefaultValue = 'Enter TSO name';
            vm.placeholder = vm.placeholderDefaultValue;
            vm.searchFocused = false;

            $scope.$watch(
                function () {
                    return vm.search.tso.searchText;
                },
                function () {
                    if (vm.search.tso.searchText !== '') {
                        vm.search.tso.name = vm.search.tso.searchText;
                    }
                }
            );

            function getTsos() {
                var param = {};
                if ($scope.filterMarketAreas.length > 0) {
                    param = {
                        marketAreaList: $scope.filterMarketAreas
                    };
                }
                if (vm.suggestions.length === 0) {
                    vm.uiLoadingInProgress = true;
                    TransmissionSystemOperator.query(
                        param,
                        function (res) {
                            vm.suggestions = res;
                            vm.uiLoadingInProgress = false;
                        },
                        function () {
                            vm.uiLoadingInProgress = false;
                        }
                    );
                }
            }

            function submitTsos() {
                var tsos = getSelectedTsos(vm.suggestions);
                $scope.submitSelection()(tsos);
                vm.uiShowSuggestions = false;
            }

            /**
             * Close the dialog and deselect all network points as a reset.
             */
            function cancel() {
                vm.uiShowSuggestions = false;
                deselectAll();
            }

            function getSelectedTsos(tsos) {
                var selectedTsos = [];
                var tmpTsos;

                for (var i = 0; i < tsos.length; i++) {
                    if (tsos[i]._checked === true) {
                        tmpTsos = angular.copy(tsos[i]);
                        delete tmpTsos._checked;
                        selectedTsos.push(tmpTsos);
                    }
                }

                var result = '';
                angular.forEach(selectedTsos, function (value) {
                    result += result === '' ? value.name : ', ' + value.name;
                });
                vm.search.tso.searchText = '';
                vm.placeholder = result;

                return selectedTsos;
            }

            function selectAll() {
                var filterSuggestions = $filter('filter')(
                    vm.suggestions,
                    vm.search.tso.name
                );
                if (filterSuggestions.length === vm.suggestions.length) {
                    angular.forEach(vm.suggestions, function (suggestion) {
                        suggestion._checked = true;
                    });
                } else {
                    angular.forEach(
                        filterSuggestions,
                        function (filterSuggestion) {
                            var suggestions = $filter('filter')(
                                vm.suggestions,
                                { id: filterSuggestion.id },
                                true
                            );
                            if (suggestions.length === 1) {
                                suggestions[0]._checked = true;
                            }
                        }
                    );
                }
            }

            function deselectAll() {
                for (var i = 0; i < vm.suggestions.length; i++) {
                    vm.suggestions[i]._checked = false;
                }
            }

            /**
             * Don't hide the dropdown when it's toggled.
             * Sometimes hiding is forced when closed via cancel button.
             */
            function onToggle() {
                vm.uiShowSuggestions = true;
            }

            /**
             * Get the width of the scrollbar of the browser.
             * This is useful when you need to adjust elements according to scrollbar width.
             *
             * @see http://www.alexandre-gomes.com/?p=115
             * @returns {number} The width in pixels of the scrollbar
             */
            function widthOfScrollbar() {
                var inner = document.createElement('p');
                inner.style.width = '100%';
                inner.style.height = '200px';

                var outer = document.createElement('div');
                outer.style.position = 'absolute';
                outer.style.top = '0px';
                outer.style.left = '0px';
                outer.style.visibility = 'hidden';
                outer.style.width = '200px';
                outer.style.height = '150px';
                outer.style.overflow = 'hidden';
                outer.appendChild(inner);

                document.body.appendChild(outer);
                var w1 = inner.offsetWidth;
                outer.style.overflow = 'scroll';
                var w2 = inner.offsetWidth;
                if (w1 == w2) {
                    w2 = outer.clientWidth;
                }

                document.body.removeChild(outer);

                return w1 - w2;
            }
        }
    }
})();
